import PropTypes from 'prop-types';
import { FiX } from 'react-icons/fi';
import ReactModal from 'react-modal';
import Clickable from '../../Buttons/Clickable';
import styles from './ModalWithTopLogo.module.css';

export const ModalWithTopLogo = ({
  isOpen,
  closeModal,
  logo,
  hasCloseButton,
  children,
  style,
  onAfterClose,
}) => {
  return (
    <ReactModal
      ariaHideApp={false}
      closeTimeoutMS={300}
      className={styles.modal}
      overlayClassName={styles.modalOverlay}
      isOpen={isOpen}
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      onAfterClose={onAfterClose}
      style={style}>
      <div className={styles.modalContentContainer}>
        <div className={styles.buffer} />
        <div className={styles.logoContainer}>
          <img src={logo} alt="modal_logo" className={styles.logo} />
        </div>
        {hasCloseButton ? (
          <Clickable
            type="button"
            onClick={closeModal}
            className={styles.closeButton}>
            <FiX className={styles.closeIcon} />
          </Clickable>
        ) : (
          <div className={styles.buffer} />
        )}
      </div>

      {children}
    </ReactModal>
  );
};

ModalWithTopLogo.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  hasCloseButton: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  logo: PropTypes.string.isRequired,
  onAfterClose: PropTypes.func,
};
ModalWithTopLogo.defaultProps = {
  hasCloseButton: false,
};
